export default __webpack_public_path__ + "static/media/minus-icon.714df7f9.svg";